import React, { useEffect } from "react";
import { useUserStore } from "../../store/userStore.js";
import { useLocation } from "react-router-dom";

import UserProfile from "../../components/userprofile/userprofile";
import UserProfileLayout from "../../components/layout/userprofilelayout/userprofilelayout";

const UserProfileOverview = () => {
  const location = useLocation();
  const { user: userData, getUser } = useUserStore();

  const username = location.pathname.split("/")[2];

  useEffect(() => {
    getprofileData();
  }, [username]);

  const getprofileData = () => {
    const payload = { username };
    getUser(payload);
  };

  return (
    <UserProfileLayout userData={userData}>
      <UserProfile />
    </UserProfileLayout>
  );
};

export default UserProfileOverview;








